module.exports = __webpack_public_path__ + "static/media/eduTechImg2.889e1a96.webp";